// GA4 identity helpers for the /pay link-generator. The visitor's GA4
// client_id is what lets a Stripe purchase (reported server-side via the
// Measurement Protocol) join back to the visitor's original session — and
// its Google Ads click.
export const GA4_MEASUREMENT_ID = "G-4H00TV5ZTY";

const clientIdFromCookie = () => {
  const m = document.cookie.match(/(?:^|;\s*)_ga=GA1\.\d+\.(\d+\.\d+)/);
  return m ? m[1] : null;
};

// Resolves { clientId, sessionId }. gtag('get') is async and can be blocked
// (ad-blockers), so fall back to the _ga cookie and never hang — worst case
// the payment link goes out unstamped and the purchase is still recorded.
export const getGa4Identity = (timeoutMs = 1500) =>
  new Promise((resolve) => {
    let settled = false;
    const finish = (clientId, sessionId) => {
      if (settled) return;
      settled = true;
      resolve({
        clientId: clientId || clientIdFromCookie(),
        sessionId: sessionId ? String(sessionId) : null,
      });
    };
    const timer = setTimeout(() => finish(null, null), timeoutMs);
    try {
      if (typeof window.gtag !== "function") {
        clearTimeout(timer);
        return finish(null, null);
      }
      window.gtag("get", GA4_MEASUREMENT_ID, "client_id", (clientId) => {
        window.gtag("get", GA4_MEASUREMENT_ID, "session_id", (sessionId) => {
          clearTimeout(timer);
          finish(clientId, sessionId);
        });
      });
    } catch {
      clearTimeout(timer);
      finish(null, null);
    }
  });
